.root {
  background-color: #131416;
  height: 100vh;
  width: 100vw;
}

:global {
  .cover-wrapper {
    margin: 0 auto;
    max-width: 30vw;
  }

  @media (max-width: 960px) {
    .cover-wrapper {
      max-width: 100% !important;
      padding: 0 1em;
    }
  }

  .cover-buttons-wrapper {
    margin-top: 4em;
  }

  .contact-wrapper {
    margin-top: 4em;

    img {
      margin-right: 1em;
    }
  }

  .resume-button {
    font-family: "IBMPlexMonoRegular";
    font-size: 1.2em;
    background: transparent;
    border: 2px solid #f5f1eb;
    box-sizing: border-box;
    border-radius: 20px;
    color: #f5f1eb;
    cursor: none !important;
    margin-top: 1em;

    &:hover {
      background: #f5f1eb;
      color: #131416;
    }
  }
}
